import { Component, Input } from "@angular/core";
import { Events, NavController, NavParams, Platform, ViewController } from "ionic-angular";
import { DownloadFormat } from "../../models/interfaces/download-format";
import { UploadPage } from "../../pages/upload/upload";
import { MemberPage } from "../../pages/member/member";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ExportData } from "../../services/export-data";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "submenucomponent",
  templateUrl: "submenucomponent.html",
})
export class SubMenuComponent {

  private menu: Array<{ title: string }>;
  private sqlviewname: string;
  private exportFileName: string;
  private hl_runno: string;

  public page;
  private data: [object];
  private title;
  private downloadFormat: any = DownloadFormat;
  private selectedFormat: DownloadFormat;
  private styleName: string ="";

  constructor(private configService: ConfigService,private events: Events, public navCtrl: NavController, public viewCtrl: ViewController, public navParams: NavParams,
    public exportData: ExportData, private db: DbserviceProvider) {
    console.log("SubMenuComponent constructor");
    this.selectedFormat = DownloadFormat.COMMA;
    this.styleName=this.configService.getConfig("STYLENAME");

    this.sqlviewname = this.navParams.get("sqlviewname");
    this.exportFileName = this.navParams.get("exportFileName");
    if (this.exportFileName === 'HarelineView') {
      this.title = 'Upload Newsletter'
    }
    else {
      this.title = 'Export To CSV'
    }

    this.menu = [
      { "title": this.title },
      // { "title": "Export To XLSX" },
    ];
  }
  private uploadNewsletter() {
    console.log("SubMenuComponent uploadNewsletter");
    this.navCtrl.push(UploadPage, { "hlrunno": this.navParams.get("hlrunno"), });

  }

  private ionViewWillEnter() {
    console.log("SubMenuComponent ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("SubMenuComponent onInitPage");
    this.hl_runno = this.navParams.get("hlrunno");

  }

  private export(item) {
    console.log("SubMenuComponent export");

    if (this.exportFileName === 'HarelineView') {
      this.uploadNewsletter();
      // this.navCtrl.push(UploadPage, {});
      //this.navCtrl.push(UploadPage, {});

    }
    else {
      console.log("SubMenuComponent export this.sqlviewname: " && this.sqlviewname);
      this.db.dbCol({
        "action": "select", "mapObject": this.sqlviewname,
      }).subscribe((datatoexport) => {
        this.data = datatoexport;
        this.exportData.export2CSV(this.data, this.selectedFormat, this.exportFileName + ".csv");
      });

      this.viewCtrl.dismiss();
    }

  }


}



// WEBPACK FOOTER //
// ./src/components/submenucomponent/submenucomponent.ts